import React from "react";
import { Check, BadgeCheck } from "lucide-react";
import { Reveal } from "./shared";
import { BADGES, IMAGES } from "../data";

const POINTS = [
  { title: "Experiență", desc: "Peste 20 de ani de practică contabilă și fiscală." },
  { title: "Profesionalism", desc: "Standarde ridicate și conformitate deplină cu legislația." },
  { title: "Relație apropiată cu clientul", desc: "Comunicare directă și consultanță pe înțelesul tău." },
  { title: "Soluții personalizate", desc: "Servicii adaptate exact nevoilor afacerii tale." },
  { title: "Digitalizare", desc: "Procese moderne, rapide și complet securizate." },
];

export const About = () => {
  return (
    <section id="despre" className="bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal className="order-2 lg:order-1">
            <div className="relative">
              <div className="rounded-[28px] overflow-hidden shadow-lift ring-1 ring-black/5">
                <img
                  src={IMAGES.about}
                  alt="Echipa AN CONTAB AUDIT analizând documente financiare"
                  className="w-full h-[380px] lg:h-[500px] object-cover"
                  loading="lazy"
                />
              </div>
              <div className="absolute -top-5 -right-5 hidden sm:block rounded-2xl bg-brand px-6 py-5 shadow-lift">
                <p className="text-3xl font-extrabold text-white leading-none">20+</p>
                <p className="text-sm text-white/80 mt-1">ani de experiență</p>
              </div>
            </div>
          </Reveal>

          <div className="order-1 lg:order-2">
            <Reveal>
              <span className="inline-flex items-center gap-2 text-brand font-semibold text-sm tracking-wide uppercase">
                <span className="h-px w-8 bg-brand" />
                Despre noi
              </span>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-4 text-3xl sm:text-4xl font-bold tracking-tight text-ink">
                Partenerul financiar al afacerii tale.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-5 text-lg text-ink-muted leading-relaxed">
                AN CONTAB AUDIT este o firmă de contabilitate care combină experiența solidă cu
                tehnologia modernă. Deservim companii din întreaga Românie, oferind
                servicii complete de contabilitate, fiscalitate și consultanță financiară,
                cu un singur scop: să îți susținem creșterea sănătoasă a afacerii.
              </p>
            </Reveal>

            <div className="mt-8 space-y-4">
              {POINTS.map((p, i) => (
                <Reveal key={p.title} delay={0.1 + i * 0.06}>
                  <div className="flex items-start gap-4">
                    <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-light">
                      <Check className="h-4 w-4 text-brand" strokeWidth={3} />
                    </span>
                    <p className="text-ink">
                      <span className="font-semibold">{p.title}.</span>{" "}
                      <span className="text-ink-muted">{p.desc}</span>
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={0.5}>
              <div className="mt-9 flex flex-wrap gap-3">
                {BADGES.map((b) => (
                  <span
                    key={b}
                    className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-gray-50 px-4 py-2 text-sm font-semibold text-ink"
                  >
                    <BadgeCheck className="h-4 w-4 text-brand" />
                    {b}
                  </span>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
